import { render, staticRenderFns } from "./WhyChampionLA.vue?vue&type=template&id=124affb6&scoped=true&"
import script from "./WhyChampionLA.vue?vue&type=script&lang=js&"
export * from "./WhyChampionLA.vue?vue&type=script&lang=js&"
import style0 from "./WhyChampionLA.vue?vue&type=style&index=0&id=124affb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124affb6",
  null
  
)

export default component.exports